export default __webpack_public_path__ + "static/media/globalCard2.3d556f92.webp";